import { ColumnData } from './column-data.class';
import { OrderData } from './order-data.class';

export class DataTableRequest {
    draw?: number;
    start?: number;
    length?: number;
    search?: any | undefined;
    isAnd?: boolean;
    columns?: ColumnData[] | undefined;
    order?: OrderData[] | undefined;
}
